<template>

<div id="app">
    <div class="container">
      <div class="logo">
    <router-link :to="{ path: '/zmist' }"><img :src="logo" class="book-logo"></router-link>
    <div class="text-logo" v-bind:class="{ tytul: isActiveTytul }">
      Улюблені колядки та щедрівки
    </div>
    <router-link :to="{ path: '/zmist' }"><img src="@/assets/ababa-logo.png" class="ababa-logo"></router-link>
    <div class="header">
      <transition name="component-fade" mode="out-in">
        <component v-bind:is="block1"></component>
      </transition>
    </div>
    <div class="text-logo" v-bind:class="{ tytul: isActiveTytul }" style="margin-top: -1px;">
      <a target="_blank" style="color: #fff;" href="http://ababahalamaha.com.ua/q/3f7yg">Книжково-музичний проєкт Івана Малковича</a>
    </div>
  </div>

      <router-view ></router-view> 

      <div class="footer">
        Усі права застережено<br />© <a target="_blank" href="http://ababahalamaha.com.ua">«А-БА-БА-ГА-ЛА-МА-ГА»</a>, 2020, 2021
      </div>  
    </div>

    <let-it-snow
  v-bind="snowConf"
  :show="show"    
/>
</div>

  

</template>


<script>
//import AppHeader from './Header'
//import Footerr from './Footer'

import LetItSnow from 'vue-let-it-snow'


export default {

   data() {
    return {
      logo: 'https://nova-radist.ababahalamaha.com/images/name_logo2.png',
    block1: 'hd',
    isActiveTytul: false,
     snowConf: {
      windPower : 0, 
      speed : 1.1,
      count : 30,
      size : 4,
      opacity : 1,
      images: ['https://nova-radist.ababahalamaha.com/images/snow_1.png',
        'https://nova-radist.ababahalamaha.com/images/snow_2.png',
        'https://nova-radist.ababahalamaha.com/images/snow_3.png']
      },
    show: false  
  
    }    
  },
  components: {
    'text_logo': {
      template: '<img src="/images/header.png">'
    },
    'hd': {
      template: ' '
    },
    LetItSnow
    
  },



  watch: {
    '$route' (to, from) {

       if (this.$route.path == '/tytul') {
        this.logo = 'https://nova-radist.ababahalamaha.com/images/name_logo.png'
        this.isActiveTytul = true
       } else {
        this.logo = 'https://nova-radist.ababahalamaha.com/images/name_logo2.png'
        this.isActiveTytul = false
       }

    }
  },

   mounted () {
      this.show = true  

      if (this.$route.path == '/tytul') {
        this.logo = 'https://nova-radist.ababahalamaha.com/images/name_logo.png'
        this.isActiveTytul = true
       } else {
        this.logo = 'https://nova-radist.ababahalamaha.com/images/name_logo2.png'
        this.isActiveTytul = false
       }

    },

  created: function() {
    setTimeout(() => this.Animation(1), 3000);

   }, 

   methods: {

    Animation(status) {

      if (status) {
        this.block1 = 'text_logo';
        setTimeout(() => this.Animation(0), 7000);
        //console.log('1')
      } else {
        this.block1 = 'hd';
        setTimeout(() => this.Animation(1), 6000);
        //console.log('0')
      }

    }

  }
  
  }

</script>